module.exports = __webpack_public_path__ + "static/media/pouring-full-1.13511355668ad558d08385d15981d7c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/features/pouring-full-1.jpg
// module id = 1881
// module chunks = 1